module.exports = "mat-row:hover {\n  background-color: #636360;\n  cursor: pointer; }\n  mat-row:hover mat-cell {\n    color: #ffffff; }\n  .section .field-row {\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/visits/visits.component.scss
// module id = ./src/app/visits/visits.component.scss
// module chunks = main